import React from 'react';
import {Glum} from '../../../puddleglum';
import {
	Button,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Stack,
	Text,
} from 'components/ui/chakra';

interface PatientSelectionModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSelect: (patientId: number) => void;
	me: Glum.Models.User;
}

const PatientSelectionModal = ({isOpen, onClose, onSelect, me}: PatientSelectionModalProps) => {
	const calculateAge = (dateOfBirth: string | Date | null): number | null => {
		if (!dateOfBirth) return null;
		const birthDate = new Date(dateOfBirth);
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
			age -= 1;
		}
		return age;
	};

	const handleSelect = (patientId: number) => {
		onSelect(patientId);
	};

	return (
		<Modal size='sm' isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
			<ModalOverlay />
			<ModalContent>
				<ModalCloseButton />
				<ModalHeader>Who is this appointment for?</ModalHeader>
				<ModalBody pb={6}>
					<Text mb={4} color='subtleText'>
						Please select who will be seen for this appointment.
					</Text>
					<Stack spacing={3}>
						<Button
							onClick={() => handleSelect(me.id)}
							w='full'
							justifyContent='space-between'
						>
							<Text>
								{me.first_name} {me.last_name} (You)
							</Text>
							{me.date_of_birth && (
								<Text fontSize='sm' fontWeight='normal'>
									Age {calculateAge(me.date_of_birth)}
								</Text>
							)}
						</Button>
						{(me.dependents ?? []).map((dependent) => (
							<Button
								key={dependent.id}
								intent='secondary'
								onClick={() => handleSelect(dependent.id)}
								w='full'
								justifyContent='space-between'
							>
								<Text>
									{dependent.first_name} {dependent.last_name}
								</Text>
								{dependent.date_of_birth && (
									<Text fontSize='sm' fontWeight='normal'>
										Age {calculateAge(dependent.date_of_birth)}
									</Text>
								)}
							</Button>
						))}
					</Stack>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default PatientSelectionModal;
